module.exports = "data:image/png;base64,UklGRoQAAABXRUJQVlA4WAoAAAAQAAAAYwAAQwAAQUxQSCYAAAABFyAWTEMAO/MoIuLAQNo2KuZsMzFnu9IaOET0fwIcWju6j4VDC1ZQOCA4AAAAkAQAnQEqZABEAD6RSKFMpaQjIiDoALASCWkAAAd2VXy9xp7yb6dOnTp06dHAAP74TQAAAAAAAAA="


//////////////////
// WEBPACK FOOTER
// ./src/Assets/nodes/Comment_Background.png
// module id = 24
// module chunks = 0